import React from 'react'
import EmptyHeader from 'containers/EmptyHeader'
import ErrorMessage from 'components/ErrorMessage'
import styled from 'styled-components'
import Button from 'components/Button'
import { IsEmbedded, NotEmbedded } from 'components/Embedding'
import { EmbeddedErrorPage } from 'modules/shares/components/EmbeddedErrorPage'
import * as Sentry from '@sentry/browser'
import { ApolloError } from 'apollo-client'
import { CenterContent } from 'containers/CenterContent'

const StyledErrorMessage = styled(ErrorMessage.Generic)`
  flex: 1 0 auto;
  max-width: 500px;
  margin: auto;
`

interface GenericErrorViewProps {
  error?: ApolloError | string
  errorTitle?: string
}

const GenericErrorView = ({ error, errorTitle }: GenericErrorViewProps) => {
  if (typeof error === 'string') {
    Sentry.captureException(error)
  } else if (error?.graphQLErrors) {
    const versionForbiddenError = error.graphQLErrors.some(e =>
      [
        'USER_CANT_VIEW_OLD_SHARE_VERSIONS',
        'USER_CANT_VIEW_VERSION_HISTORY',
        'USER_CANT_VIEW_SHARE_VERSION',
      ].includes(e.extensions?.reason)
    )

    if (!versionForbiddenError) {
      Sentry.captureException(error)
    }
  }

  return (
    <>
      <NotEmbedded>
        <CenterContent>
          <EmptyHeader />
          <StyledErrorMessage
            title={errorTitle || 'There was an error loading this information'}
            extra={
              <Button
                variant="primary"
                onClick={() => window.location.reload()}>
                Refresh the page to try again
              </Button>
            }
          />
        </CenterContent>
      </NotEmbedded>
      <IsEmbedded>
        <EmbeddedErrorPage for="unknown" />
      </IsEmbedded>
    </>
  )
}

export default GenericErrorView
